<header
    class="text-[var(--ssds-text-neutral-bold)] lg:text-[var(--ssds-text-brand-regular)] font-medium bg-[var(--ssds-surface-neutral-minimal)] fixed w-full z-50"
>
    <div class="border-b border-default-color">
        <div
            class="flex items-center px-[var(--ssds-layout-spacing-xs)] gap-[var(--ssds-layout-spacing-md)] lg:container justify-between self-stretch mx-auto h-[64px] lg:px-6 lg:h-[72px] lg:justify-start lg:self-auto"
        >
            <div class="lg:flex" [ngClass]="{ hidden: trayOpened }">
                <a
                    href="https://www.statestreet.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="State Street (opens in new tab)"
                >
                    <svg
                        id="Layer_1"
                        aria-hidden="true"
                        focusable="false"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        viewBox="0 0 576 158"
                        height="28"
                    >
                        <defs>
                            <style>
                                .cls-1 {
                                    fill: #001aff;
                                    stroke-width: 0px;
                                }
                            </style>
                        </defs>
                        <g id="Logo">
                            <path
                                id="Wordmark"
                                class="cls-1"
                                d="M190.58,64.82v-16.02c9.35,6.47,20.8,9.45,28.16,9.45,8.56,0,14.83-1.79,14.83-7.46,0-3.38-2.69-5.18-7.86-6.57l-14.53-3.78c-10.55-2.79-20.4-6.47-20.4-19.31C190.78,5.51,206.4.03,221.33.03c7.17,0,14.53,1.09,21.89,3.88v14.13c-8.76-3.38-17.12-4.38-24.28-4.38-8.66,0-13.43,1.89-13.43,6.07,0,2.89,2.29,4.58,8.36,6.17l15.23,3.98c12.04,3.18,19.11,8.76,19.11,19.7,0,14.13-13.14,22.39-29.06,22.39-11.74-.1-20.5-2.19-28.56-7.17ZM274.47,69.7h14.83V15.36h22.99V1.63h-60.81v13.73h22.99v54.34ZM397.2,69.7h14.83V15.36h22.99V1.63h-60.81v13.73h22.99v54.34ZM304.94,69.7h16.22l6.37-16.22h31.45l6.57,16.22h16.02L352.71,1.63h-18.91l-28.86,68.07ZM332.9,40.34l8.76-22.99h3.18l8.76,22.99h-20.7ZM445.47,69.7h51.95v-13.73h-37.52v-14.23h31.35v-13.73h-31.35v-12.64h36.22V1.63h-50.65v68.07ZM219.14,157.97c15.92,0,29.06-8.26,29.06-22.39,0-10.95-7.07-16.52-19.11-19.7l-15.23-3.98c-6.07-1.59-8.36-3.28-8.36-6.17,0-4.18,4.78-6.07,13.43-6.07,7.17,0,15.53,1,24.28,4.38v-14.13c-7.36-2.79-14.73-3.88-21.89-3.88-14.93,0-30.55,5.47-30.55,21.1,0,12.84,9.85,16.52,20.4,19.31l14.53,3.78c5.17,1.39,7.86,3.18,7.86,6.57,0,5.67-6.27,7.46-14.83,7.46-7.36,0-18.81-2.99-28.16-9.45v16.02c8.06,4.98,16.82,7.07,28.56,7.17ZM274.47,155.68h14.83v-54.34h22.99v-13.73h-60.81v13.73h22.99v54.34ZM538.18,155.68h14.83v-54.34h22.99v-13.73h-60.81v13.73h22.99v54.34ZM391.9,155.68h51.95v-13.73h-37.52v-14.23h31.35v-13.73h-31.35v-12.64h36.22v-13.73h-50.65v68.07ZM454.79,155.68h51.95v-13.73h-37.52v-14.23h31.35v-13.73h-31.35v-12.64h36.22v-13.73h-50.65v68.07ZM322.73,155.68h14.63v-24.28h11.25l18.21,24.28h17.61l-19.31-26.07c9.85-2.79,15.03-9.75,15.03-20,0-14.13-9.45-21.99-26.67-21.99h-30.75v68.07ZM337.36,117.76v-16.42h17.91c6.07,0,9.85,3.18,9.85,8.26s-3.68,8.16-9.85,8.16h-17.91Z"
                            />
                            <path
                                id="Symbol"
                                class="cls-1"
                                d="M75.04,18.39C99.72,9.83,125.79.48,157.44.48v21.89c-27.67,0-50.56,8.16-75.24,16.72C57.72,47.65,31.65,57,0,57v-21.89c27.67,0,50.56-8.16,75.04-16.72ZM0,67.95h157.44v22.09H0v-22.09ZM0,135.62c27.67,0,50.56-8.16,75.04-16.72,24.68-8.56,50.75-17.91,82.4-17.91v21.89c-27.67,0-50.56,8.16-75.24,16.72C57.72,148.16,31.65,157.51,0,157.51v-21.89Z"
                            />
                        </g>
                    </svg>
                </a>
            </div>

            <div
                class="text-[length:var(--ssds-font-size-heading)] lg:text-[length:var(--ssds-font-size-product)] font-light lg:font-medium"
            >
                Data Intelligence
            </div>

            <button
                type="button"
                class="pl-6 pr-2 lg:hidden cursor-pointer"
                [attr.aria-label]="trayOpened ? 'Close menu' : 'Open menu'"
                [attr.aria-expanded]="trayOpened"
                (click)="toggleTray()"
            >
                <svg
                    *ngIf="!trayOpened"
                    aria-hidden="true"
                    focusable="false"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.13867 13.6659V12.3839H15.8674V13.6659H2.13867ZM2.13867 9.63873V8.36111H15.8674V9.63873H2.13867ZM2.13867 5.61592V4.33398H15.8674V5.61592H2.13867Z"
                        fill="#020B5B"
                    />
                </svg>

                <svg
                    *ngIf="trayOpened"
                    aria-hidden="true"
                    focusable="false"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4.66856 14.2262L3.77344 13.3311L8.10469 8.99981L3.77344 4.66856L4.66856 3.77344L8.99981 8.10469L13.3311 3.77344L14.2262 4.66856L9.89494 8.99981L14.2262 13.3311L13.3311 14.2262L8.99981 9.89494L4.66856 14.2262Z"
                        fill="#020B5B"
                    />
                </svg>
            </button>
        </div>
    </div>
    <div
        class="border-default-color border-b overflow-auto"
        [ngClass]="{
            '!border-b-0 lg:!border-b': trayOpened
        }"
    >
        <div
            class="flex flex-col lg:flex-row items-center gap-[var(--ssds-layout-spacing-xs)] lg:gap-[var(--ssds-layout-spacing-xl)] lg:h-[var(--ssds-component-sizing-120)] mx-auto lg:px-6 lg:container"
            [ngClass]="{
                'px-[var(--ssds-layout-spacing-xs)]': !trayOpened,
                'h-[calc(100vh-64px)]': trayOpened
            }"
        >
            <div
                class="flex items-center gap-[var(--ssds-layout-spacing-xl)] h-[42px] w-full lg:w-auto lg:border-none"
                [ngClass]="{ 'border-b border-default-color': trayOpened }"
            >
                <span
                    class="h-[42px] flex items-center justify-center"
                    [ngClass]="{ 'w-full': trayOpened }"
                    >Private Capital Indices</span
                >
                <span
                    class="h-6 w-px bg-[var(--ssds-border-neutral-subtler)] hidden lg:inline-flex"
                ></span>
            </div>
            <pci-navbar
                class="lg:flex w-full lg:w-atuo lg:flex-1"
                [ngClass]="{ hidden: !trayOpened }"
                (linkClicked)="onNavLinkClicked()"
            ></pci-navbar>
            <!-- Login button aligned to the right -->
            <div
                class="lg:flex py-[var(--ssds-layout-spacing-2xs)] flex-1 lg:flex-initial"
                [ngClass]="{ hidden: !trayOpened, 'lg:hidden': currentUrl === '/login' }"
            >
                <button
                    class="lg:inline-flex items-center px-[var(--ssds-component-padding-lg)] border border-[var(--ssds-border-brand-regular)] text-[var(--ssds-font-size-label)] h-[var(--ssds-component-sizing-100)] lg:h-[36px] bg-[var(--ssds-surface-brand-regular)] lg:bg-white text-[var(--ssds-text-inverse-neutral-bold)] lg:text-[var(--ssds-text-brand-regular)]"
                    (click)="login()"
                >
                    Login
                </button>
            </div>

            <div class="lg:hidden pt-8 pb-8" [ngClass]="{ hidden: !trayOpened }">
                <svg
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    viewBox="0 0 576 158"
                    height="28"
                >
                    <defs>
                        <style>
                            .cls-1 {
                                fill: #001aff;
                                stroke-width: 0px;
                            }
                        </style>
                    </defs>
                    <g id="Logo">
                        <path
                            id="Wordmark"
                            class="cls-1"
                            d="M190.58,64.82v-16.02c9.35,6.47,20.8,9.45,28.16,9.45,8.56,0,14.83-1.79,14.83-7.46,0-3.38-2.69-5.18-7.86-6.57l-14.53-3.78c-10.55-2.79-20.4-6.47-20.4-19.31C190.78,5.51,206.4.03,221.33.03c7.17,0,14.53,1.09,21.89,3.88v14.13c-8.76-3.38-17.12-4.38-24.28-4.38-8.66,0-13.43,1.89-13.43,6.07,0,2.89,2.29,4.58,8.36,6.17l15.23,3.98c12.04,3.18,19.11,8.76,19.11,19.7,0,14.13-13.14,22.39-29.06,22.39-11.74-.1-20.5-2.19-28.56-7.17ZM274.47,69.7h14.83V15.36h22.99V1.63h-60.81v13.73h22.99v54.34ZM397.2,69.7h14.83V15.36h22.99V1.63h-60.81v13.73h22.99v54.34ZM304.94,69.7h16.22l6.37-16.22h31.45l6.57,16.22h16.02L352.71,1.63h-18.91l-28.86,68.07ZM332.9,40.34l8.76-22.99h3.18l8.76,22.99h-20.7ZM445.47,69.7h51.95v-13.73h-37.52v-14.23h31.35v-13.73h-31.35v-12.64h36.22V1.63h-50.65v68.07ZM219.14,157.97c15.92,0,29.06-8.26,29.06-22.39,0-10.95-7.07-16.52-19.11-19.7l-15.23-3.98c-6.07-1.59-8.36-3.28-8.36-6.17,0-4.18,4.78-6.07,13.43-6.07,7.17,0,15.53,1,24.28,4.38v-14.13c-7.36-2.79-14.73-3.88-21.89-3.88-14.93,0-30.55,5.47-30.55,21.1,0,12.84,9.85,16.52,20.4,19.31l14.53,3.78c5.17,1.39,7.86,3.18,7.86,6.57,0,5.67-6.27,7.46-14.83,7.46-7.36,0-18.81-2.99-28.16-9.45v16.02c8.06,4.98,16.82,7.07,28.56,7.17ZM274.47,155.68h14.83v-54.34h22.99v-13.73h-60.81v13.73h22.99v54.34ZM538.18,155.68h14.83v-54.34h22.99v-13.73h-60.81v13.73h22.99v54.34ZM391.9,155.68h51.95v-13.73h-37.52v-14.23h31.35v-13.73h-31.35v-12.64h36.22v-13.73h-50.65v68.07ZM454.79,155.68h51.95v-13.73h-37.52v-14.23h31.35v-13.73h-31.35v-12.64h36.22v-13.73h-50.65v68.07ZM322.73,155.68h14.63v-24.28h11.25l18.21,24.28h17.61l-19.31-26.07c9.85-2.79,15.03-9.75,15.03-20,0-14.13-9.45-21.99-26.67-21.99h-30.75v68.07ZM337.36,117.76v-16.42h17.91c6.07,0,9.85,3.18,9.85,8.26s-3.68,8.16-9.85,8.16h-17.91Z"
                        />
                        <path
                            id="Symbol"
                            class="cls-1"
                            d="M75.04,18.39C99.72,9.83,125.79.48,157.44.48v21.89c-27.67,0-50.56,8.16-75.24,16.72C57.72,47.65,31.65,57,0,57v-21.89c27.67,0,50.56-8.16,75.04-16.72ZM0,67.95h157.44v22.09H0v-22.09ZM0,135.62c27.67,0,50.56-8.16,75.04-16.72,24.68-8.56,50.75-17.91,82.4-17.91v21.89c-27.67,0-50.56,8.16-75.24,16.72C57.72,148.16,31.65,157.51,0,157.51v-21.89Z"
                        />
                    </g>
                </svg>
            </div>
        </div>
    </div>
</header>
